import React from 'react';
import { Form, Formik } from 'formik';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { FormInputField } from '../../common/components/formFields';
import validationSchema from './ChangePasswordValidation.schema';
import { overrideUserPassword } from '../UsersActions';

function ChangePasswordForm({ onCloseAlert, userId }) {
  const dispatch = useDispatch();

  return (
    <Formik
      initialValues={{ password: '', passwordRepeat: '' }}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        dispatch(overrideUserPassword(userId, values));
        onCloseAlert();
      }}
    >
      {() => (
        <Form autoComplete="off">
          <div className="change-password_form-wrapper">
            <h4 className="mb-3">Override Password</h4>
            <FormInputField name="password" label="Password" type="password" />
            <FormInputField name="passwordRepeat" label="Confirm Password" type="password" />
            <div className="change-password__buttons-container">
              <Button type="submit" className="rounded-pill btn-primary">
                Save
              </Button>
              <Button className="rounded-pill btn-soft-primary" onClick={() => onCloseAlert()}>
                Cancel
              </Button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default ChangePasswordForm;

ChangePasswordForm.propTypes = {
  onCloseAlert: PropTypes.func,
  userId: PropTypes.string,
};

ChangePasswordForm.defaultProps = {
  onCloseAlert: () => {},
  userId: '',
};
